import { Controller } from "@hotwired/stimulus"
import { emojiBlast } from "emoji-blast"

// Connects to data-controller="emoji-blast"
export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.shootingStars.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("click", this.shootingStars.bind(this))
  }

  shootingStars(event) {
    // Don't prevent default - let the link work
    
    const star = (yPos) => {
      emojiBlast({
        emojiCount: 1,
        emojis: ["⭐️"],
        physics: {
          fontSize: { max: 32, min: 20 },
          gravity: 0.05,
          initialVelocities: {
            x: 45,
            y: -10
          }
        },
        position: {
          x: 0,
          y: yPos
        }
      })
    }

    const sparkles = (yPos, size) => {
      emojiBlast({
        emojiCount: 1,
        emojis: ["✨"],
        physics: {
          fontSize: size,
          gravity: 0.05,
          initialVelocities: {
            rotation: 0,
            x: 45,
            y: -10
          }
        },
        position: {
          x: 0,
          y: yPos
        }
      })
    }

    const shootingStar = () => {
      const randYPos = Math.random() * innerHeight + 100
      let emojiSize = 18
      star(randYPos)
      const intervalId2 = setInterval(() => {
        sparkles(randYPos, emojiSize)
        emojiSize -= 3
      }, 60)
      setTimeout(() => {
        clearInterval(intervalId2)
      }, 400)
    }

    const intervalId = setInterval(shootingStar, 60)
    setTimeout(() => {
      clearInterval(intervalId)
    }, 2000)
  }
}
